import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { EmailVeryficationErrorView } from 'views/email-verification-error';

export const EmailVeryficationError = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.emailVeryficationError',
    });
    
    return (
        <div>
            <CustomHeader title={t('title')} />
            <EmailVeryficationErrorView />
        </div>
    );
};
